var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":_vm.items,"return-object":_vm.isObjectValue,"value":_vm.defaultValue,"append-icon":_vm.dropdownIcon,"label":"Models","item-value":"value","item-text":"text","dense":""},on:{"change":_vm.changeValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }